

var BaiduMap = function () {



  var map = undefined;
  var markerClusterer = undefined;//聚合工具

  var loaded = false; //是否已经加载
  var drawingManager = false; //画图工具
  var circleArray = [];
  var polygonArray = [];
  var polyLineArray = [];
  var markerArray = [];
  var clustererArray = [];
  var labelArray = [];

  var EarthRadiusKm = 6378.137; // WGS-84

  function normalizeColor(color, defaultColor = "#CD3700") {
    if (!color) return defaultColor;
    if (!isNaN(color)) return "#" + color.toString(16);
    return color.length === 7 ? color : defaultColor;
  }

  function getElementById(elements, id) {
    return elements.find(element => element.id === id);
  }
  function removeElementFromArr(elements, id) {


    if (!elements) return;

    if (id) {
      const index = elements.findIndex(element => element.id === id);
      if (index !== -1) {
        map.removeOverlay(elements[index].overlay);
        elements.splice(index, 1);
      }
    } else {
      elements.forEach(element => map.removeOverlay(element.overlay));
      elements.length = 0;
    }

  }


  this.loadScript = function (url) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    document.body.appendChild(script);
  }
  this.showCluster = function () {
    if (map) {

    }
  }
  this.removeClustererById = function (id) {
    console.log("removeClustererById" + id)
    // removeElementFromArr(labelArray, id);
    if (id) {
      for (var i = 0; i < clustererArray.length; i++) {
        if (clustererArray[i].id == id) {
          markerClusterer.removeMarker(clustererArray[i].overlay)
          clustererArray.splice(i, 1);
          break;
        }
      }
    }
  },
    this.addMarkerToCluster = function (id, name, lng, lat, iconUrl, callback) {
      // console.log("addMarkerToCluster")


      if (!loaded) return;
      if (lng == undefined || lat == undefined) return false;
      if (id == undefined || id == "") id = "marker0";
      if (name == undefined) name = "marker";
      var myIcon = undefined;
      if (iconUrl)
        myIcon = new BMap.Icon(require("@/" + iconUrl), new BMap.Size(22, 32), {
          anchor: new BMap.Size(10, 25),
        });

      var point = new BMap.Point(lng, lat);
      // map.setCenter(point);
      var marker = new BMap.Marker(point, { icon: myIcon });

      if (callback) marker.addEventListener("click", callback);
      var label = new BMap.Label(name, {
        position: point,
        offset: new BMap.Size(-30, 35),
      });
      label.setStyle({
        // 设置label的样式
        color: "#444444",
        fontSize: "13px",
        border: "1px solid #DDDDDD",
        backGround: "#FFFFFF",
        padding: "3px",
      });
      marker.setLabel(label);

      clustererArray.push({
        id: id, overlay: marker
      });


      // console.log("添加聚合点");
      // console.log(point);
      var p = marker.getPosition();
      // console.log(p);
      if (!markerClusterer) {
        markerClusterer = new BMapLib.MarkerClusterer(map, {
          isAverageCenter: false,
          markers: [marker]
        });
      } else {
        markerClusterer.addMarker(marker)
      }






    }

  /*
    opts = {
      center: [116.404, 39.915],中心点经纬度
      zoom: 12,缩放级别
    }
    */
  this.initMap = function (mapId, opts) {
    if (loaded || map !== undefined) {
      return Promise.resolve(map);
    }

    try {
      // 参数验证
      if (!mapId) {
        throw new Error('Map ID is required');
      }

      opts = opts || { coordsType: 5 };

      // 加载百度地图主脚本

      // 返回 Promise 以处理异步初始化


      // 初始化地图
      map = new BMap.Map(mapId, {
        enableMapClick: false,
        coordsType: opts.coordsType == 5 ? BMAP_COORD_GCJ02 : BMAP_COORD_BD09, //BMAP_COORD_WGS84, //  BMAP_COORD_BD09 BMAP_COORD_GCJ02
        // coordsType: opts.coordsType,
      });

      // 设置中心点和缩放级别
      const center = opts.center || [116.404, 39.915];
      const zoom = opts.zoom || 14;
      map.centerAndZoom(new BMap.Point(center[0], center[1]), zoom);

      // 添加地图控件
      map.addControl(new BMap.MapTypeControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
      }));

      const navigationControl = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        type: BMAP_NAVIGATION_CONTROL_LARGE,
        enableGeolocation: false,
      });
      map.addControl(navigationControl);
      map.enableScrollWheelZoom(true);

      // 监听地图加载完成事件
      const tilesLoadedHandler = () => {
        if (!loaded && opts.completed) {
          loaded = true;
          opts.completed();
        }
        map.removeEventListener("tilesloaded", tilesLoadedHandler);

      };

      map.addEventListener("tilesloaded", tilesLoadedHandler);



    } catch (error) {
      console.error('Failed to initialize Baidu Map:', error);
      throw error;
    }

  };



  this.clearAll = function () {
    map.clearOverlays();
    // 清空所有内部数组
    markerArray.length = 0;
    polyLineArray.length = 0;
    polygonArray.length = 0;
    circleArray.length = 0;
    clustererArray.length = 0;
    labelArray.length = 0;
    // 重置聚合器
    if (markerClusterer) {
      markerClusterer.clearMarkers();
    }
  };

  this.setCenter = function (lng, lat) {
    console.log("setCenter", lng, lat);

    var myLatLng = new BMap.Point(lng, lat);
    map.setCenter(myLatLng);
  };

  //添加点
  this.addMarker = function (id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight) {

    // console.log("addMarker1");

    if (!loaded) return;
    // console.log("addMarker2");
    if (lng == undefined || lat == undefined) return false;
    if (id == undefined || id == "") id = "marker0";
    if (name == undefined) name = "marker";
    var myIcon = undefined;
    if (iconUrl) {
      if (iconWidth == undefined) {
        iconWidth = 22
      }
      if (iconHeight == undefined) {
        iconHeight = 32
      }
      myIcon = new BMap.Icon(require("@/" + iconUrl), new BMap.Size(iconWidth, iconHeight), {
        anchor: new BMap.Size(10, 25),
        imageSize: new BMap.Size(iconWidth, iconHeight),

      });
    }

    var point = new BMap.Point(lng, lat);
    // map.setCenter(point);
    // console.log("setCenter", lng, lat);
    var marker = new BMap.Marker(point, { icon: myIcon });

    if (callback) marker.addEventListener("click", callback);

    map.addOverlay(marker);

    markerArray.push({ id: id, overlay: marker });

    //添加对应的label
    var label = new BMap.Label(name, {
      position: point,
      offset: new BMap.Size(-30, 10),
    });
    label.setStyle({
      // 设置label的样式
      color: "#444444",
      fontSize: "13px",
      border: "1px solid #DDDDDD",
      backGround: "#FFFFFF",
      padding: "3px",
    });

    map.addOverlay(label);
    labelArray.push({ id: id, overlay: label });
    return marker;
  };
  //添加线
  this.addPolyline = function (id, name, coordinators, width, color, isArrow) {
    console.log("addPolyline1");

    if (!loaded) return;

    if (coordinators == undefined || coordinators == "") return false;
    if (id == undefined || id == "") id = "line0";
    if (name == undefined) name = "";
    if (width == undefined || width == "") width = 1;
    if (color == undefined || color == "") color = "#CD3700";
    if (!isNaN(color)) color = "#" + color.toString(16);
    if (color.length != 7) color = "#CD3700";

    isArrow = isArrow || false
    //只有在百度地图的标准下才会显现箭头

    var curvPoints1 = [];
    for (var i = 0; i < coordinators.length; i++) {
      if (coordinators[i].lat != undefined && coordinators[i].lng)
        curvPoints1.push(
          new BMap.Point(coordinators[i].lng, coordinators[i].lat)
        );
    }


    //添加箭头
    var sy = new BMap.Symbol(BMap_Symbol_SHAPE_BACKWARD_OPEN_ARROW, {
      scale: 0.6,//图标缩放大小
      strokeColor: '#fff',//设置矢量图标的线填充颜色
      strokeWeight: '2',//设置线宽
    });
    var icons = new BMap.IconSequence(sy, '10', '30');

    var points = curvPoints1;
    var curvLine1 = new BMap.Polyline(points, {
      strokeColor: color,
      icons: isArrow ? [icons] : [],
      strokeOpacity: 0.8,
      strokeWeight: width,
    });

    //

    map.addOverlay(curvLine1);
    console.log("addPolyline2");
    var v = map.getViewport(points);
    map.centerAndZoom(v.center, v.zoom);
    polyLineArray.push({ id: id, overlay: curvLine1 });
  };
  this.removeMarkerById = function (id) {
    if (!loaded) return;
    removeElementFromArr(markerArray, id);

    removeElementFromArr(labelArray, id);
  };
  this.clearMarkers = function (id) {
    if (!loaded) return;
    removeElementFromArr(markerArray);
    removeElementFromArr(labelArray);
  };

  this.removePolylineById = function (id) {
    if (!loaded) return;
    removeElementFromArr(polyLineArray, id);
  };
  this.removePolygonById = function (id) {
    if (!loaded) return;
    removeElementFromArr(polygonArray, id);
  };
  //添加多边形
  this.addPolygon = function (
    id,
    name,
    coordanites,
    strokeWidth,
    strokeColor,
    fillColor
  ) {
    //console.log('addPolygon');

    if (!loaded) return;
    if (coordanites == undefined || coordanites == "") return false;
    if (id == undefined || id == "") id = "region0";
    if (name == undefined) name = "";

    if (strokeWidth == undefined || strokeWidth == "") strokeWidth = 1;
    var markerPositions = [];

    for (var i = 0; i < coordanites.length; i++)
      markerPositions.push(
        new BMap.Point(coordanites[i].lng, coordanites[i].lat)
      );

    if (strokeColor == undefined || strokeColor == "") strokeColor = "#CD3700";
    if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
    if (strokeColor.length != 7) strokeColor = "#CD3700";

    if (fillColor == undefined || fillColor == "") fillColor = "#B3EE3A";
    if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);

    if (fillColor.length != 7) fillColor = "#B3EE3A";

    var polygon = new BMap.Polygon(markerPositions, {
      strokeColor: strokeColor,
      strokeWeight: strokeWidth,
      strokeOpacity: 0.5,
      fillColor: fillColor,
      fillOpacity: 0.35,
    });

    map.addOverlay(polygon);

    //
    var v = map.getViewport(markerPositions);
    // console.log(v);
    if (v) map.centerAndZoom(v.center, v.zoom);
    polygonArray.push({ id: id, overlay: polygon });
  };
  this.addCircle = function (
    id,
    lnglat,
    radius,
    strokeWidth,
    strokeColor,
    fillColor
  ) {
    if (!loaded) return;
    if (lnglat == undefined || radius == undefined) return false;
    if (id == undefined || id == "") id = "circle0";
    if (strokeWidth == undefined || strokeWidth == "") strokeWidth = 1;

    var centerLonlat = new BMap.Point(lnglat.lng, lnglat.lat);
    // console.log(centerLonlat)
    strokeColor = strokeColor || "#CD3700";
    if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
    if (strokeColor.length != 7) strokeColor = "#CD3700";
    fillColor = fillColor || "#B3EE3A";
    if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
    if (fillColor.length != 7) fillColor = "#B3EE3A";

    var circle = new BMap.Circle(centerLonlat, parseFloat(radius), {
      strokeColor: strokeColor,
      fillColor: fillColor,
      fillOpacity: 0.35,
      strokeWeight: strokeWidth,
      strokeOpacity: 0.8,
    }); //创建圆

    map.addOverlay(circle);

    radius = parseFloat(radius) + 1500;
    var lon = parseFloat(centerLonlat.lng);
    var lat = parseFloat(centerLonlat.lat);

    var leftdownlon =
      lon + (Math.sin(235 * (3.1415 / 180)) * radius) / 111319.5555;
    var leftdownlat =
      lat + (Math.cos(235 * (3.1415 / 180)) * radius) / 111319.5555;
    var leftdownlonFl = parseFloat(leftdownlon).toFixed(8);
    var leftdownlatFl = parseFloat(leftdownlat).toFixed(8);

    var rightuplon =
      lon + (Math.sin(45 * (3.1415 / 180)) * radius) / 111319.5555;
    var rightuplat =
      lat + (Math.cos(45 * (3.1415 / 180)) * radius) / 111319.5555;

    var rightuplonFl = parseFloat(rightuplon).toFixed(8);
    var rightuplatFl = parseFloat(rightuplat).toFixed(8);

    var p = [];

    p.push(new BMap.Point(leftdownlon, leftdownlat));
    // p.push(new BMap.Point(leftdownlonFl,leftdownlatFl));
    p.push(new BMap.Point(rightuplon, rightuplat));
    // p.push(new BMap.Point(rightuplonFl,rightuplatFl));

    var v = map.getViewport(p);
    map.centerAndZoom(v.center, v.zoom);

    circleArray.push({ id: id, overlay: circle });
  };
  this.cancelDraw = function () {
    map.clearOverlays();
    if (drawingManager)
      drawingManager.close();
  };
  this.drawPoint = function (callback) {
    if (!loaded) return;

    map.clearOverlays();

    drawingManager = new BMapLib.DrawingManager(map);
    drawingManager.setDrawingMode(BMAP_DRAWING_MARKER);

    drawingManager.open();

    drawingManager.addEventListener("markercomplete", function (overlay) {
      drawingManager.close();
      var p = overlay.getPosition();

      if (callback) callback(p.lng, p.lat);
    });
  };
  this.drawRectangle = function (width, color, fillColor, callback) {
    if (!loaded) return;
    width = width || 2;
    color = color || "#CD3700";
    if (!isNaN(color)) color = "#" + color.toString(16);
    if (color.length != 7) color = "#CD3700";
    fillColor = fillColor || "#B3EE3A";
    if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
    if (fillColor.length != 7) fillColor = "#B3EE3A";

    map.clearOverlays();

    drawingManager = new BMapLib.DrawingManager(map, {
      rectangleOptions: {
        strokeColor: color, //边线颜色。
        fillColor: fillColor, //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: width, //边线的宽度，以像素为单位。
        strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
        fillOpacity: 0.35, //填充的透明度，取值范围0 - 1。
        strokeStyle: "solid", //边线的样式，solid或dashed。
      },
    });

    drawingManager.setDrawingMode(BMAP_DRAWING_RECTANGLE);

    drawingManager.open();

    //返回内容 左上角 leftLon, leftLat, 右下角 rightLon, rightLat

    drawingManager.addEventListener("rectanglecomplete", function (overlay) {
      drawingManager.close();
      //   console.log(overlay);
      var bounds = overlay.getBounds();
      var sw = bounds.getSouthWest();
      var ne = bounds.getNorthEast();

      if (callback) callback(sw.lng, sw.lat, ne.lng, ne.lat);
    });
  };

  this.drawPolygon = function (width, color, fillColor, callback) {
    if (!loaded) return;
    width = width || 2;
    color = color || "#CD3700";
    if (!isNaN(color)) color = "#" + color.toString(16);
    if (color.length != 7) color = "#CD3700";
    fillColor = fillColor || "#B3EE3A";
    if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
    if (fillColor.length != 7) fillColor = "#B3EE3A";

    map.clearOverlays();

    drawingManager = new BMapLib.DrawingManager(map, {
      polygonOptions: {
        strokeColor: color, //边线颜色。
        fillColor: fillColor, //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: width, //边线的宽度，以像素为单位。
        strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
        fillOpacity: 0.35, //填充的透明度，取值范围0 - 1。
        strokeStyle: "solid", //边线的样式，solid或dashed。
      },
    });

    drawingManager.setDrawingMode(BMAP_DRAWING_POLYGON);

    drawingManager.open();

    //返回内容 左上角 leftLon, leftLat, 右下角 rightLon, rightLat

    drawingManager.addEventListener("polygoncomplete", function (overlay) {
      drawingManager.close();
      var path = overlay.getPath();

      var lonlats = "";
      for (var i = 0; i < path.length; i++) {
        if (lonlats != "") lonlats += ";";

        lonlats += path[i].lng + "," + path[i].lat;
      }
      if (callback) callback(lonlats);
    });
  };

  this.drawLine = function (width, color, callback) {
    if (!loaded) return;
    width = width || 2;
    color = color || "#0609D8";
    if (!isNaN(color)) color = "#" + color.toString(16);
    if (color.length != 7) color = "#0609D8";

    map.clearOverlays();

    drawingManager = new BMapLib.DrawingManager(map, {
      polylineOptions: {
        strokeColor: color, //边线颜色。

        strokeWeight: width, //边线的宽度，以像素为单位。
        strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
        fillOpacity: 0.35, //填充的透明度，取值范围0 - 1。
        strokeStyle: "solid", //边线的样式，solid或dashed。
      },
    });

    drawingManager.setDrawingMode(BMAP_DRAWING_POLYLINE);

    drawingManager.open();

    //返回内容 左上角 leftLon, leftLat, 右下角 rightLon, rightLat

    drawingManager.addEventListener("polylinecomplete", function (overlay) {
      drawingManager.close();
      var path = overlay.getPath();

      var lonlats = "";
      for (var i = 0; i < path.length; i++) {
        if (lonlats != "") lonlats += ";";

        lonlats += path[i].lng + "," + path[i].lat;
      }
      if (callback) callback(lonlats);
    });
  };

  this.drawCircle = function (width, color, fillColor, callback) {
    if (!loaded) return;
    width = width || 2;
    color = color || "#CD3700";
    if (!isNaN(color)) color = "#" + color.toString(16);
    if (color.length != 7) color = "#CD3700";
    fillColor = fillColor || "#B3EE3A";
    if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
    if (fillColor.length != 7) fillColor = "#B3EE3A";

    map.clearOverlays();

    drawingManager = new BMapLib.DrawingManager(map, {
      circleOptions: {
        strokeColor: color, //边线颜色。
        fillColor: fillColor, //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: width, //边线的宽度，以像素为单位。
        strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
        fillOpacity: 0.35, //填充的透明度，取值范围0 - 1。
        strokeStyle: "solid", //边线的样式，solid或dashed。
      },
    });

    drawingManager.setDrawingMode(BMAP_DRAWING_CIRCLE);

    drawingManager.open();

    //返回内容 左上角 leftLon, leftLat, 右下角 rightLon, rightLat

    drawingManager.addEventListener("circlecomplete", function (overlay) {
      drawingManager.close();
      var center = overlay.getCenter();
      var radius = overlay.getRadius();

      if (callback) callback(center.lng, center.lat, radius);
    });
  };

  this.pointToLineDist = function (x1, y1, x2, y2, x0, y0) {
    var space = 0;
    var a, b, c;
    a = this.calcDistance(x1, y1, x2, y2); // 线段的长度
    b = this.calcDistance(x1, y1, x0, y0); // (x1,y1)到点的距离
    c = this.calcDistance(x2, y2, x0, y0); // (x2,y2)到点的距离
    if (c <= 0.000001 || b <= 0.000001) {
      space = 0;
      return space;
    }
    if (a <= 0.000001) {
      space = b;
      return space;
    }
    if (c * c >= a * a + b * b) {
      space = b;
      return space;
    }

    if (b * b >= a * a + c * c) {
      space = c;
      return space;
    }

    var p = (a + b + c) / 2; // 半周长
    var s = Math.sqrt(p * (p - a) * (p - b) * (p - c)); // 海伦公式求面积
    space = (2 * s) / a; // 返回点到线的距离（利用三角形面积公式求高）
    return space;
  };

  this.calcDistance = function (p1Lng, p1Lat, p2Lng, p2Lat) {
    var dLat1InRad = p1Lat * (Math.PI / 180);
    var dLong1InRad = p1Lng * (Math.PI / 180);
    var dLat2InRad = p2Lat * (Math.PI / 180);
    var dLong2InRad = p2Lng * (Math.PI / 180);
    var dLongitude = dLong2InRad - dLong1InRad;
    var dLatitude = dLat2InRad - dLat1InRad;
    var a =
      Math.pow(Math.sin(dLatitude / 2), 2) +
      Math.cos(dLat1InRad) *
      Math.cos(dLat2InRad) *
      Math.pow(Math.sin(dLongitude / 2), 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var dDistance = EarthRadiusKm * c;
    return dDistance * 1000;
  };

  //定义一些常量
  var x_PI = (3.14159265358979324 * 3000.0) / 180.0;
  var PI = 3.1415926535897932384626;
  var a = 6378245.0;
  var ee = 0.00669342162296594323;

  /**
   * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
   * 即 百度 转 谷歌、高德
   * @param bd_lon
   * @param bd_lat
   * @returns {*[]}
   */
  function bd09togcj02(bd_lon, bd_lat) {
    var x_pi = (3.14159265358979324 * 3000.0) / 180.0;
    var x = bd_lon - 0.0065;
    var y = bd_lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    var gg_lng = z * Math.cos(theta);
    var gg_lat = z * Math.sin(theta);
    return { lng: gg_lng, lat: gg_lat };
  }

  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
   * 即谷歌、高德 转 百度
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  function gcj02tobd09(lng, lat) {
    var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
    var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
    var bd_lng = z * Math.cos(theta) + 0.0065;
    var bd_lat = z * Math.sin(theta) + 0.006;
    return { lng: bd_lng, lat: bd_lat };
  }

  /**
   * WGS84转GCj02
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  function wgs84togcj02(lng, lat) {
    if (out_of_china(lng, lat)) {
      return [lng, lat];
    } else {
      var dlat = transformlat(lng - 105.0, lat - 35.0);
      var dlng = transformlng(lng - 105.0, lat - 35.0);
      var radlat = (lat / 180.0) * PI;
      var magic = Math.sin(radlat);
      magic = 1 - ee * magic * magic;
      var sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
      dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
      var mglat = lat + dlat;
      var mglng = lng + dlng;
      return { lng: mglng, lat: mglat };
    }
  }

  /**
   * GCJ02 转换为 WGS84
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  function gcj02towgs84(lng, lat) {
    if (out_of_china(lng, lat)) {
      return [lng, lat];
    } else {
      var dlat = transformlat(lng - 105.0, lat - 35.0);
      var dlng = transformlng(lng - 105.0, lat - 35.0);
      var radlat = (lat / 180.0) * PI;
      var magic = Math.sin(radlat);
      magic = 1 - ee * magic * magic;
      var sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
      dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
      mglat = lat + dlat;
      mglng = lng + dlng;
      return [lng * 2 - mglng, lat * 2 - mglat];
    }
  }

  function transformlat(lng, lat) {
    var ret =
      -100.0 +
      2.0 * lng +
      3.0 * lat +
      0.2 * lat * lat +
      0.1 * lng * lat +
      0.2 * Math.sqrt(Math.abs(lng));
    ret +=
      ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
        2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) /
      3.0;
    ret +=
      ((160.0 * Math.sin((lat / 12.0) * PI) +
        320 * Math.sin((lat * PI) / 30.0)) *
        2.0) /
      3.0;
    return ret;
  }

  function transformlng(lng, lat) {
    var ret =
      300.0 +
      lng +
      2.0 * lat +
      0.1 * lng * lng +
      0.1 * lng * lat +
      0.1 * Math.sqrt(Math.abs(lng));
    ret +=
      ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
        2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) /
      3.0;
    ret +=
      ((150.0 * Math.sin((lng / 12.0) * PI) +
        300.0 * Math.sin((lng / 30.0) * PI)) *
        2.0) /
      3.0;
    return ret;
  }
  /**
   * 判断是否在国内，不在国内则不做偏移
   * @param lng
   * @param lat
   * @returns {boolean}
   */
  function out_of_china(lng, lat) {
    return (
      lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271 || false
    );
  }
};

export { BaiduMap };
